export const objectToFormData = object => {
    const arrayToFormData = (key, value, formData) => {
        value.forEach((val, index) => {
            if (typeof val !== 'object') {
                formData.append(`${key}[${index}]`, val)
                return
            }
    
            Object.entries(val).forEach(v => {
                if (Array.isArray(v[1])) {
                    const aKey = `${key}[${index}][${v[0]}]`
                    const aValue = v[1] === null ? '' : v[1]
                    arrayToFormData(aKey, aValue, formData)
                } else {
                    const val = v[1] === null ? '' : v[1]
                    formData.append(`${key}[${index}].${v[0]}`, val)
                }
            })
        })
    }

    const formData = new FormData()
    Object.entries(object).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            arrayToFormData(key, value, formData)
        } else {
            const val = value === null ? '' : value
            formData.append(key, val)
        }
    })
    return formData
}

/**
 * Búsqueda de una clave dado su valor dentro de un objeto/array
 * 
 * Ejemplos de uso:
 * const foo = { data: { data2: { data3: 'worked' }, data21: 'rand' }, data4: { id: 15, name: 'find me!' } }
 * console.log(findKeyByValue(foo, (found) => found === 'worked'))
 * console.log(findKeyByValue(foo, (found) => found && found.id && found.id === 15))
 * @param {*} obj Objeto/Array en el que realizar la búsqueda
 * @param {*} equalsExpression Expresión para localizar la clave del objeto/array
 * @returns Devuelve la clave del objeto/array
 */
export const findKeyByValue = (obj, equalsExpression) => {
    for (var [key, v] of Object.entries(obj)) {
        if (Array.isArray(v)) {
            for (let i = 0; i < v.length; i++) {
                let res = findKeyByValue(v[i], equalsExpression)
                if (res !== null && res !== undefined) return res
            }
        } else {
            if (v !== null && v !== undefined) {
                if (typeof (v) === 'object') {
                    if (equalsExpression(v)) return key
                    let res = findKeyByValue(v, equalsExpression)
                    if (res !== null && res !== undefined) return res
                }
                else {
                    let res = equalsExpression(v)
                    if (res) return key
                }
            }
            else continue
        }
    }
}

/**
 * Búsqueda de un valor dada su clave dentro de un objeto
 * @param {*} object Objeto en el que realizar la búsqueda
 * @param {*} key Clave a buscar dentro del objeto
 * @returns Devuelve el valor del objeto
 */
export const findValueByKey = (object, key) => {
    let value
    Object.keys(object).some(k => {
        if (k === key) {
            value = object[k]
            return true
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findValueByKey(object[k], key)
            return value !== undefined
        }
    })
    return value
}